import cx from "classnames";
import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import { emoteToolMenuAtomActive } from "@/interface/AppStore";
import { EMOTIONS_PATHS } from "@/tools/emoteTool/emoteTool";
import styles from "./EmoteMenu.module.css";

export const EmoteMenu = () => {
    const activeEmotion = useAtomValue(emoteToolMenuAtomActive);

    const handleSelectEmotion = (path: string) => {
        canv.toolBox.Tools.emoteTool.setEmotePath(path);
    };

    return (
        <div className={styles.emoteMenu}>
            {EMOTIONS_PATHS.map((path) => {
                return (
                    <button
                        key={path}
                        className={cx(styles.emoteContainer, {
                            [styles.emoteContainerSelected]: activeEmotion === path,
                        })}
                        onClick={() => handleSelectEmotion(path)}
                        type="button"
                    >
                        <img alt="emote" src={canv.toolBox.Tools.emoteTool.getEmoteUrl(path)} />
                    </button>
                );
            })}
        </div>
    );
};
